var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',[_c('el-col',[_c('executive-board-member-menu')],1),_vm._v(" "),_c('el-col',[_c('executive-board-member-applications-lane',{attrs:{"assignedApplications":_vm.assignedApplications}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2dfc4be6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExecutiveBoardMember.vue
// module id = null
// module chunks = 